// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__BBH35","productName":"Table_productName__Yj01J"};